/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect } from "react";
import { useAppDispatch } from "../../../hooks";
import { getAllAd } from "../../../store/advertisement/advertisement-action";
import { useAuth } from "../../modules/auth";
import { EngageWidget11 } from "../../../_flyingPaws/partials/widgets/_new/engage/AdPopupBannerFrom";
import { PopupBannerTable } from "../../../_flyingPaws/partials/widgets/tables/AddPopUpBannerTable";

const PopupBanner: FC = () => (
  <>
    <div className="row g-5 g-xl-5 mb-5 mb-xl-0 ">
      <div className=" col-xxl">
        <EngageWidget11 className="h-md-100" />
      </div>
    </div>

    <div className="row gy-5 gx-xl-8">
      <div
        style={{ backgroundColor: "#000F1E" }}
        className=" border-0 pt-5 rounded card-header col-xl"
      >
        <PopupBannerTable className="card-xxl-stretch mb-5 mb-xl-5" />
      </div>
    </div>
  </>
);

const AddPopupBanners: FC = () => {
  const dispatch = useAppDispatch();
  const { currentUser } = useAuth();
  useEffect(() => {
    if (currentUser) {
      dispatch(getAllAd({ page: 1 }));
    }
  }, [currentUser, dispatch]);
  return (
    <>
      <PopupBanner />
    </>
  );
};

export { AddPopupBanners };
